import { render, staticRenderFns } from "./StepFlow.vue?vue&type=template&id=b68bc7ea&"
import script from "./StepFlow.vue?vue&type=script&lang=js&"
export * from "./StepFlow.vue?vue&type=script&lang=js&"
import style0 from "./StepFlow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b68bc7ea')) {
      api.createRecord('b68bc7ea', component.options)
    } else {
      api.reload('b68bc7ea', component.options)
    }
    module.hot.accept("./StepFlow.vue?vue&type=template&id=b68bc7ea&", function () {
      api.rerender('b68bc7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/wizard/flow/StepFlow.vue"
export default component.exports